module.exports = __webpack_public_path__ + "assets/img/roosterplatform-process-center.632fe72a.png";